/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { SalesAgreement, SalesAgreementProductLine } from '../storage';

function isSalesAgreement(x: SalesAgreementProductLine | SalesAgreement): x is SalesAgreement {
  return (x as SalesAgreement).totalCommitted !== undefined;
}

export const getAvailableQuantity = (x: SalesAgreementProductLine | SalesAgreement) => {
  if (isSalesAgreement(x)) {
    const availableAmount = x.totalCommitted - x.totalInvoiced - x.totalFulfilled - x.totalReleased;
    return availableAmount;
  } else {
    const availableAmount = x.quantity.remaining;
    return availableAmount;
  }
};
